'use client';

import { useEffect, useRef } from 'react';
import { STORAGE_KEYS } from '@/constants/storageKeys';
import { refreshAccessToken } from '@/libs/services/axiosInstance';
import { forceLogout } from '@/libs/helpers/forceLogout';
import { useAppDispatch } from '@/store/hook';

export function ExpiryWatcher() {
  const dispatch = useAppDispatch();
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    const BUFFER_MS = 60_000; // 到期前 60 秒 refresh（建議不要 5 秒）
    const clear = () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
      timerRef.current = null;
    };

    const schedule = () => {
      clear();

      const raw = localStorage.getItem(STORAGE_KEYS.tokenExpiresAt);
      if (!raw) return;

      const expiresAt = Number(raw);
      if (!Number.isFinite(expiresAt)) return;

      const msLeft = expiresAt - Date.now();

      // 快到期：立刻 refresh
      if (msLeft <= BUFFER_MS) {
        void doRefresh();
        return;
      }

      timerRef.current = window.setTimeout(() => {
        void doRefresh();
      }, msLeft - BUFFER_MS);
    };

    const doRefresh = async () => {
      try {
        await refreshAccessToken();
        schedule(); // refresh 成功後重新排下一次
      } catch {
        forceLogout(dispatch);
      }
    };

    schedule();

    const onVisible = () => {
      if (document.visibilityState === 'visible') schedule();
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      clear();
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [dispatch]);

  return null;
}
